import { ActorFilterRegistryCategory } from '../ActorFilterRegistryCategory';
import { ActorFilterRegistryItem } from '../ActorFilterRegistryItem';
export class ActorFilterItem extends ActorFilterRegistryCategory {
    label = 'Item';
    constructor(parent) {
        super(parent);
        for (let n = 1; n <= 10; n++) {
            this[`item${n}`] = () => new ActorFilterRegistryItem({
                filter: ({ a }) => a.itemNumber === n,
            });
        }
        super.init();
    }
    item2ToN = () => new ActorFilterRegistryItem({
        filter: ({ a }) => a.itemNumber > 0,
    });
    unshuffledItemByNumber = () => new ActorFilterRegistryItem({
        filter: ({ trait, a }) => a.unshuffledItemNumber === trait.local.valueOf.number1To10,
        params: { core: ['number1To10'] },
    });
}
